module.exports = __webpack_public_path__ + "img/user-acquasition-bg.48a62ea2.png";